import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Seo } from "@/components/Seo";

export default function BrandPage() {
  const { brand } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.getBrand(brand).then(setData).catch(() => setData({ brand: "Brand", products: [] }));
  }, [brand]);

  if (!data) return <div className="pt-32 text-center text-cream/60">Loading…</div>;
  return (
    <div className="pt-16" data-testid="brand-page">
      <Seo title={`${data.brand} | Saunas & Recovery Equipment | The Recovery Shops`}
        description={`Shop ${data.brand} saunas, heaters and recovery equipment at The Recovery Shops. Premium quality with expert advice and white-glove delivery. Request a quote.`} />
      <div className="bg-charcoal border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14">
          <p className="overline">Brand</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-2">{data.brand}</h1>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
    </div>
  );
}
